var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dropdown-address-selector',{attrs:{"clear-address":_vm.clearAddress,"currency":_vm.currency,"title":_vm.title},on:{"toAddress":function($event){return _vm.getToAddress($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }